export default {
  setConfigHeader: (state, payload) => (state.header = payload),
  setConfigFooter: (state, payload) => (state.footer = payload),
  setConfigMenu: (state, payload) => (state.menu = payload),
  setConfigSidebar: (state, payload) => (state.sidebar = payload),
  setConfigLayout: (state, payload) => (state.config = payload),
  setConfigDefaultPage: (state, payload) => (state.defaultPage = payload),
  setConfigLogin: (state, payload) => (state.login = payload),
  setConfigTheme: (state, payload) => (state.theme = payload),
  setConfigBreadcrumbs: (state, payload) => (state.breadcrumbs = payload),
  setHeaderOptions: (state, payload) => (state.header.class = payload),
  setNavbarOptions: (state, payload) => (state.navbar.class = payload),
  setConfigDialogs: (state, payload) => (state.dialogs = payload),
  setConfigLoading: (state, payload) => (state.loading = payload),
  setConfigPaths: (state, payload) => (state.paths = payload),
  setConfigExpiredMessage: (state, payload) => (state.expiredMessage = payload),
  setConfigForm: (state, payload) => (state.form = payload),
  setConfigDefaultActions: (state, payload) => (state.defaultActions = payload),
  setConfigEnvironmentDefaults: (state, payload) => (state.environmentDefaults = payload)
};
